import React from "react";

import "./StripePromo.scss";

import IconStripe from "venuescanner-js/react/components/Objects/Icons/IconStripe";
import IconTick from "venuescanner-js/react/components/Objects/Icons/IconTick";

function StripePromo({ venue, onClick }) {
  return (
    <div className="stripe-promo">
      <div className="stripe-promo__header">
        <div className="stripe-promo__icon">
          <IconStripe />
        </div>
        <h1>Get paid quicker with online pay</h1>
      </div>
      <p className="stripe-promo__subheading">
        Active your free Stripe account today
      </p>

      <div className="stripe-promo__list">
        <div className="stripe-promo__list-item">
          <Bullet />
          <p>Win more bookings</p>
        </div>

        <div className="stripe-promo__list-item">
          <Bullet />
          <p>No need to chase for payment</p>
        </div>

        <div className="stripe-promo__list-item">
          <Bullet />
          <p>No card processing fees</p>
        </div>
      </div>

      <div className="stripe-promo__line" />

      <div className="stripe-promo__ctas">
        <a
          className="button"
          target="_blank"
          rel="noreferrer"
          href={`/manage/venues/${venue._id.toString()}#payment-details`}
          onClick={onClick}
        >
          Find out more
        </a>
        <button className="button button--outline-white" onClick={onClick}>
          Skip
        </button>
      </div>
    </div>
  );
}

function Bullet() {
  return (
    <div className="stripe-promo__bullet">
      <IconTick width="10" height="10" />
    </div>
  );
}

export default StripePromo;
